import React from "react";

import ProgramWrapper from "common/entities/programWrapper/ProgramWrapper";
import { FlexJustify } from "common/fragments/Flex";
import Loading from "common/fragments/Loading";
import NonIdealState from "common/fragments/NonIdealState";
import { BlockVariant, BlockView } from "common/views/block/BlockView.view";
import { ButtonVariant, ButtonView } from "common/views/button/Button.view";
import { CardVariant, CardView } from "common/views/card/Card.view";
import HeadingView, { HeadingVariant } from "common/views/heading/Heading.view";
import PageLinkView from "common/views/pageLink/PageLink.view";
import ProgressBarView from "common/views/progressBar/ProgressBar.view";
import { Query } from "core/api/typedQuery";
import { IPanelProps, Panel } from "core/decorators/Panel";
import { isEmpty } from "core/util/ArrayUtils";
import { iDef } from "core/util/TypeUtils";
import { PARAM_PROGRAM_ID } from "panels/program/Program.panel";
import Program from './entities/Program';
import labelProvider from './Programs.labels';
import Config from './ProgramsConfig';

const ManyPrograms = Query.queryMany<Program, {}>(Program);
const { Labels } = labelProvider;
@Panel({id: "programs", configClass: Config, labelProvider})
export default class ProgramsPanel extends React.PureComponent<IPanelProps<Config>> {

	public render() {
		const { config } = this.props;

		const pageSize = iDef(config.pageSize) ? config.pageSize : 5;

		return (
			<ManyPrograms params={{pageSize}}>
				{
					({ data, loading }) => {
						if (loading) {
							return <Loading />;
						}

						if (isEmpty(data)) {
							return (
								<NonIdealState
									title={<Labels.ProgramsEmpty />}
									description={<Labels.ProgramNotfoundDescription />}
								/>
							);
						}

						return data.map((program) => {
							const pw = new ProgramWrapper(program);

							return (
								<CardView key={pw.getId()} variant={CardVariant.SURFACE} viewKey="card">
									<BlockView variant={BlockVariant.CARD_CONTENT} viewKey="card-content">
										<FlexJustify>
											<div style={{flexGrow: 1}}>
												<HeadingView viewKey="name" children={pw.getName()} />
												{
													config.showProgress && (
														<ProgressBarView value={pw.getAggregateProgressPercent()} viewKey="progress" />
													)
												}
											</div>
											<div>
												<PageLinkView params={{[PARAM_PROGRAM_ID]: pw.getId()}} viewKey="view-link">
													<ButtonView variant={ButtonVariant.PRIMARY} viewKey="view-button">
														<Labels.ViewDetails />
													</ButtonView>
												</PageLinkView>
											</div>
										</FlexJustify>
									</BlockView>
								</CardView>
							);
						});
					}
				}
			</ManyPrograms>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/programs/Programs.panel.tsx